import defineComponent from 'flight';

function SideMenuNotificationsUI() {
    this.defaultAttrs({
        cartNotificationsSelector: '[data-side-menu-notifications]',
        cartNotificationDataCountAttribute: 'side-menu-notifications-count'
    });

    this._init = function () {
        this._initCartNotifications();
    };

    this._initCartNotifications = function () {
        let cartNotificationsSelector = this.select('cartNotificationsSelector');
        let cartNotificationCount = cartNotificationsSelector.data(this.attr.cartNotificationDataCountAttribute);

        cartNotificationsSelector.text(cartNotificationCount === 0 ? '' : cartNotificationCount);

        this._triggerNotificationUpdate(0, cartNotificationCount);
    };

    this._updateCartNotificationCount = function (evt, payload) {
        let cartNotificationCount = payload.totalCount;
        let cartNotificationsSelector = this.select('cartNotificationsSelector');
        let previousCount = cartNotificationsSelector.data(this.attr.cartNotificationDataCountAttribute);

        cartNotificationsSelector.data(this.attr.cartNotificationDataCountAttribute, cartNotificationCount);
        cartNotificationsSelector.text(cartNotificationCount === 0 ? '' : cartNotificationCount);

        this._triggerNotificationUpdate(previousCount, cartNotificationCount);
    };

    this._triggerNotificationUpdate = function (previousCount, newCount) {

        if (previousCount === newCount) {
            return;
        }

        let payload = {
            previousCount: previousCount,
            newCount: newCount
        };

        this.trigger(document, 'ui:site-header-notifications:update', payload);
    };

    this.after('initialize', function () {
        this._init();
        this.on(document, 'data:cart:after-get-summary', this._updateCartNotificationCount);
    });
}

module.exports = defineComponent.component(SideMenuNotificationsUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/side-menu-notifications-ui.js